import { relationshipSummaryModel } from "../../models";
const sortByCompanyName = isVendor => (a, b) => {
  const nameA = isVendor ? a.customer.name.toLowerCase() : a.vendor.name.toLowerCase();
  const nameB = isVendor ? b.customer.name.toLowerCase() : b.vendor.name.toLowerCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};
const sortById = (a, b) => a.id < b.id ? -1 : 1;
const sortByEffectiveDate = (a, b) => b.effectiveDate && a.effectiveDate && b.effectiveDate.getTime() - a.effectiveDate.getTime();
const sortByAssignee = (a, b) => {
  const nameA = (relationshipSummaryModel.sellerFullName(a) || '').toLowerCase();
  const nameB = (relationshipSummaryModel.sellerFullName(b) || '').toLowerCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
};
export let HeaderColId = /*#__PURE__*/function (HeaderColId) {
  HeaderColId["companyName"] = "companyName";
  HeaderColId["status"] = "status";
  HeaderColId["paymentMethod"] = "paymentMethod";
  HeaderColId["effectiveDate"] = "effectiveDate";
  HeaderColId["lastBilled"] = "lastBilled";
  HeaderColId["assignee"] = "assignee";
  return HeaderColId;
}({});
export const sortFunctions = {
  [HeaderColId.companyName]: _ref => {
    let {
      isAscending,
      isVendor
    } = _ref;
    return (a, b) => {
      const retval = sortByCompanyName(isVendor)(a, b) || sortById(a, b);
      return isAscending ? -retval : retval;
    };
  },
  [HeaderColId.status]: _ref2 => {
    let {
      isAscending
    } = _ref2;
    return (a, b) => {
      const retval = sortByAgreementStatus(a, b) || sortById(a, b);
      return isAscending ? -retval : retval;
    };
  },
  [HeaderColId.lastBilled]: _ref3 => {
    let {
      isAscending
    } = _ref3;
    return (a, b) => {
      const retval = sortByLastBilledDate(a, b) || sortById(a, b);
      return isAscending ? -retval : retval;
    };
  },
  [HeaderColId.paymentMethod]: _ref4 => {
    let {
      isAscending
    } = _ref4;
    return (a, b) => {
      const retval = sortByPaymentMethod(a, b) || sortById(a, b);
      return isAscending ? -retval : retval;
    };
  },
  [HeaderColId.effectiveDate]: _ref5 => {
    let {
      isAscending
    } = _ref5;
    return (a, b) => {
      const retval = sortByEffectiveDate(a, b) || sortById(a, b);
      return isAscending ? -retval : retval;
    };
  },
  [HeaderColId.assignee]: _ref6 => {
    let {
      isAscending
    } = _ref6;
    return (a, b) => {
      const retval = sortByAssignee(a, b) || sortById(a, b);
      return isAscending ? -retval : retval;
    };
  }
};
const agreementStatusSortOrder = {
  [relationshipSummaryModel.AgreementStatus.Active]: 2,
  [relationshipSummaryModel.AgreementStatus.Exhausted]: 3,
  [relationshipSummaryModel.AgreementStatus.Terminated]: 4
};
function sortByLastBilledDate(a, b) {
  if (!a.lastBilledDate && !b.lastBilledDate) return 0;
  if (!a.lastBilledDate) return 1;
  if (!b.lastBilledDate) return -1;
  return b.lastBilledDate.getTime() - a.lastBilledDate.getTime();
}
function sortByAgreementStatus(a, b) {
  return agreementStatusSortOrder[relationshipSummaryModel.agreementStatus(a)] - agreementStatusSortOrder[relationshipSummaryModel.agreementStatus(b)];
}
function sortByPaymentMethod(a, b) {
  return getPaymentMethodOrder(a.fundingSource) - getPaymentMethodOrder(b.fundingSource);
}
function getPaymentMethodOrder(pm) {
  if (!pm) return 5;
  if (pm.isCreditCard()) return 4;
  if (pm.isVerified()) return 3;
  if (pm.isPendingMicroDeposit()) return 2;
  // failed bankAccount
  return 1;
}
export function sortAgreements(config) {
  const {
    agreements,
    sort,
    isVendor,
    headerItems
  } = config;
  const result = agreements.slice();
  if (sort) {
    var _headerItems$sort$col;
    const colId = (_headerItems$sort$col = headerItems[sort.colIndex]) === null || _headerItems$sort$col === void 0 ? void 0 : _headerItems$sort$col.id;
    if (colId) {
      result.sort(sortFunctions[colId]({
        isVendor,
        isAscending: sort.sort === 'asc'
      }));
    }
  }
  return result;
}